import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { CurrentServiceIdentitySchema } from '../service-identity';
import { ServiceAccountResponseSchema } from './service-account-response.dto';
export const CurrentServiceAccountResponseSchema = ServiceAccountResponseSchema.extend({
    serviceIdentity: CurrentServiceIdentitySchema,
    memberId: z.string(),
});
export class CurrentServiceAccountResponseDto extends createZodDto(CurrentServiceAccountResponseSchema) {
}
